<div class="dialog-title">
  {{ title }}
</div>


<div class="value-container" >
  <div fxLayout="row wrap" matLine>
    <div class="full-col">
      <div class="xsDesc-f">
        Full Name(as per NRIC)
      </div>
      <div class="value-f">
        {{result?.name || result?.fullName || '-'}}
      </div>
    </div>

    <div class="full-col" *ngIf="data.contactId">
      <div class="xsDesc-f">
        NRIC / Passport No.
      </div>
      <div class="value-f">
        {{result?.icNo || '-'}}
      </div>
    </div>
    <div class="half-col" *ngIf="data.contactId">
      <div class="xsDesc-f">
        Salutation
      </div>
      <div class="value-f">
        {{result?.salutation?.name || '-'}}
      </div>
    </div>
    <div class="half-col" *ngIf="data.contactId">
      <div class="xsDesc-f">
        Income Range
      </div>
      <div class="value-f">
        {{result?.incomeRange?.range || '-'}}
      </div>
    </div>
    <div class="half-col" *ngIf="data.contactId">
      <div class="xsDesc-f">
        Race
      </div>
      <div class="value-f">
        {{result?.race?.name || '-'}}
      </div>
    </div>
    <div class="half-col" *ngIf="data.contactId">
      <div class="xsDesc-f">
        Nationality
      </div>
      <div class="value-f">
        {{result?.nationality?.name || '-'}}
      </div>
    </div>


    <div class="full-col">
      <div class="xsDesc-f">Mobile No</div>
      <div class="value-f download-link" (click)="callTo(result?.contactNo || result?.phoneNo)">{{result?.contactNo || result?.phoneNo|| '-'}}
      </div>
    </div>

    <div class="full-col">
      <div class="xsDesc-f">Email Address</div>
      <div class="value-f download-link" (click)="mailTo(result?.email)">
        {{result?.email || '-'}}</div>
    </div>

  </div>
</div>